import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Button, Icon } from 'shared/components';

import theme from './ConfirmUpdateGroupedAppointmentModal.scss';

const propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  onCancel: PropTypes.func.isRequired,
  onOk: PropTypes.func.isRequired,
};

const ConfirmUpdateGroupedAppointmentModal = ({ intl, onCancel, onOk }) => (
  <React.Fragment>
    <div className={ theme.header }>
      <div>
        <FormattedMessage
          id="AdminConsole.Appointments.DetailedView.CustomerDetails.EditGroupedAppt.Message.Title"
          defaultMessage="** Update grouped appointment"
        />
      </div>
      <button onClick={ onCancel } className={ theme.closingIconContainer } aria-label={ intl.formatMessage({ id: 'General.Cancel', defaultMessage: '** Cancel' }) }>
        <Icon name="naked-x" />
      </button>
    </div>

    <div className={ theme.body }>
      <FormattedMessage
        id="AdminConsole.Appointments.DetailedView.CustomerDetails.EditGroupedAppt.Message.Body"
        defaultMessage="** Are you sure you want to update this grouped appointment? The data you change will also change the data of the other appointments in the group"
      />
    </div>

    <div className={ theme.footer }>
      <Button
        testId="update-group-appointment-confirm-dismiss"
        label={ intl.formatMessage({
          id: 'AdminConsole.Appointments.DetailedView.CustomerDetails.EditGroupedAppt.Message.DismissButton',
          defaultMessage: '** Dismiss',
        }) }
        onClick={ onCancel }
        buttonType="naked"
        labelColor="blackMedium"
      />
      <Button
        testId="update-group-appointment-confirm-modal"
        label={ intl.formatMessage({
          id: 'AdminConsole.Appointments.DetailedView.CustomerDetails.EditGroupedAppt.Message.YesButton',
          defaultMessage: '** Yes, update',
        }) }
        onClick={ onOk }
        background="primary"
      />
    </div>
  </React.Fragment>
);

ConfirmUpdateGroupedAppointmentModal.propTypes = propTypes;

export default ConfirmUpdateGroupedAppointmentModal;
